<template>
  <v-app id="inspire" ref="document">
    <notification />
    <component v-bind:is="layout"></component>
    <versionupdate />
  </v-app>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import AppLayout from '@/layouts/AppLayout.vue'
import LoginLayout from '@/layouts/LoginLayout.vue'
import Notification from '@/components/Notification.vue'
//import MessagingMixin from '@/mixins/messaging'
import * as VueGoogleMaps from 'vue2-google-maps'
import { gmapApi } from 'vue2-google-maps'
import Vue from 'vue'
import offline from '@/store/offline/index'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import LogRocket from 'logrocket'
import Versionupdate from '@/components/Versionupdate.vue'
import axios from 'axios'

import './forms'

if (process.env.VUE_APP_ENV != 'local') {
  console.log('No Sentry or Logrocket for local')
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })

  LogRocket.init(process.env.VUE_APP_LOGROCKET_PROJECT)
  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra('sessionURL', sessionURL)
    })
  })
}
Vue.use(VueGoogleMaps, {
  load: false
})

export default {
  name: 'App',
  components: {
    'app-layout': AppLayout,
    'login-layout': LoginLayout,
    notification: Notification,
    versionupdate: Versionupdate
  },
  mixins: [],
  data() {
    return {
      timer: false,
      posDisabled: false,
      destinationPayload: null,
      endpoint: `${process.env.VUE_APP_API_URL}/forms/{form}`,
      formData: {}
    }
  },

  created() {},

  async mounted() {
    const testEngineers = process.env.VUE_APP_TEST_ENGINEERS.split(',')
    this.listenServiceWorker()
    // this.initialState()
    if (this.isLogged && this.getAccessToken) {
      this.attachAuthHeader(this.$axios)
    }

    this.attachAuthRefresh({})

    if (this.isLogged) {
      const user = localStorage.getItem('logged_user')

      this.readCalls().then(() => {
        this.setLocation()

        var route = _.isEmpty(this.getActiveCall) ? 'callsList' : 'activeCall'
        if (this.$route.name !== route) {
          try {
            this.$router.push({ name: route })
          } catch (e) {
            console.log(e)
          }
        }
      })
      if (!user || user == 'undefined') {
        this.fetchUser()
      } else {
        this.setUser(JSON.parse(user))
      }
      if (
        this.user &&
        testEngineers.includes(this.user.username.toUpperCase())
      ) {
        this.setTestUser(true)
      }

      await this.fetchForms({})
      for (const form of this.forms) {
        this.fetchFormSchemas(form.slug)
      }
    } else {
      // Already doing this in router.js
      // this.$router.push({ name: 'login' })
    }
  },

  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      getAccessToken: 'root/getAccessToken',
      isLogged: 'root/isLogged',
      getActiveCall: 'calls/getActiveCall',
      hasActiveCall: 'calls/hasActiveCall',
      latestLocation: 'location/latestLocation',
      user: 'root/user',
      getFormData: 'calls/getFormData',
      activeCall: 'calls/getActiveCall'
    }),
    ...mapState({
      forms: state => state.calls.forms
    }),
    layout() {
      return this.$route.meta.layout || this.$store.getters['root/layout']
    },
    google: gmapApi
  },
  methods: {
    ...mapActions({
      attachAuthHeader: 'root/attachAuthHeader',
      attachAuthRefresh: 'root/attachAuthRefresh',
      initialState: 'root/initialState',
      rootApplyInitialState: 'root/applyInitialState',
      locationApplyInitialState: 'location/applyInitialState',
      readCalls: 'calls/readCalls',
      fetchUser: 'root/fetchUser',
      setUser: 'root/setUser',

      replaceCallList: 'calls/replaceCallList',
      addMedia: 'calls/addMedia',
      updateMedia: 'calls/updateMedia',
      replaceMedia: 'calls/replaceMedia',

      fetchLocation: 'location/fetch',
      recordLocation: 'location/record',
      syncFromOfflinePositions: 'location/syncFromOffline',
      getDirections: 'location/directions',
      getETA: 'location/eta',

      // Requests
      oneOfflineRequest: 'root/oneOfflineRequest',
      offlineFallback: 'root/offlineFallback',
      registerForPushNotifications: 'root/registerForPushNotifications',
      fetchForms: 'calls/fetchForms',
      updateFormSchemas: 'calls/updateFormSchemas'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION',
      setTestUser: 'root/SET_TEST_USER'
    }),

    reloadApp() {
      window.location.reload()
    },

    // Listen service worker
    listenServiceWorker() {
      if ('serviceWorker' in navigator) {
        this.registerForPushNotifications()
        const that = this
        navigator.serviceWorker.addEventListener('message', function(event) {
          console.log('Message from SW', event.data) // Hello World !
          if (typeof event.data === 'object') {
            switch (event.data.type) {
              case 'setCallList':
                that.replaceCallList(event.data.data)
                break
              case 'offline-requests-sync':
                that.offlineRequests(event.data.data).then(() => {
                  console.log('ALL OFFLINE REQUESTS RESOLVED')
                })
                break
              case 'pos-sync':
                that.syncFromOfflinePositions(event.data.data)
                break
              case 'initial-state':
                console.log('Received initial state', event.data.data)
                that.rootApplyInitialState(event.data.data)
                that.locationApplyInitialState(event.data.data)
                break
              case 'get-version':
                console.log('Version is ', event.data.data)
                break
              case 'inbox-message': {
                let data = event.data.data
                console.log('Received inbox message', data)
                let color = data.color ? data.color : '#388e3c'
                let timeout = data.timeout ? data.timeout : 6000
                let title = data.title ? data.title : ''
                let message = data.body ? data.body : ''
                let deep_link = data.deep_link ? data.deep_link : ''
                that.setNotification({
                  message: message,
                  color: color,
                  timeout: timeout,
                  title: title,
                  deep_link: deep_link
                })
                break
              }
            }
          }
        })
      }
    },

    setLocation() {
      const disabled =
        this.posDisabled || process.env.VUE_APP_SEND_POSITION_DISABLED || false
      if (disabled === 'true') {
        console.log(
          'Get location disabled in .env file - see VUE_APP_SEND_POSITION_DISABLED'
        )
        return
      }

      // Fetch the location
      this.fetchLocation()
        // Collect information about distance to site and ETA
        .then(pos => {
          pos.routeParams = null
          const origin = new window.google.maps.LatLng(
            pos.coords.latitude,
            pos.coords.longitude
          )

          const destination = new window.google.maps.LatLng(
            this.getActiveCall.latitude,
            this.getActiveCall.longitude
          )
          if (this.hasActiveCall()) {
            pos.routeParams = {
              callId: this.activeCallId,
              origin: origin,
              destination: destination
            }
          }
          return pos
        })

        // Record the position
        .then(pos => {
          if (pos.routeParams) {
            this.getETA(pos.routeParams)
              .then(r => {
                //console.log('ETA Result', r)
                if (r.status === 'OK') {
                  pos.coords.distance_to_site = r.distance.value
                  pos.coords.eta = r.duration.value
                }
                this.recordLocation(pos.coords)
                return pos
              })
              .catch(e => {
                this.recordLocation(pos.coords)
                console.error(e)
              })
          }
          // this.recordLocation(pos.coords)
        })

        // Log any exceptions
        .catch(e => {
          if (e.code == 1) {
            this.setNotification({
              message:
                'You must enable location to use this app, if you denied location service you will need to remove the app from the blacklist. Click the Help link below or contact your controller who will walk you through the process.',
              color: 'error',
              timeout: 20000,
              showHelp: true
            })
          }
          console.error('********************************', e)
        })

        // Schedule the next position measurement
        .finally(() => {
          const interval = process.env.VUE_APP_SEND_POSITION_INTERVAL || 10000
          /*
          console.log(
            'Run setLocation() again in ' + interval + ' milliseconds'
          )
          */
          this.timer = setTimeout(() => {
            this.setLocation()
          }, interval)
        })
    },

    offlineRequests(requests) {
      var that = this
      return new Promise((resolve, reject) => {
        if (!requests.length) {
          resolve()
          return
        }
        const r = requests.shift()

        return this.oneOfflineRequest(r)
          .then(info => {
            return that.postProcessOfflineRequest(info)
          })
          .then(() => {
            // Delete offline request
            that.offlineFallback(r).then(f => {
              offline.deleteOfflineRequest(r.id)
            })
            return that.offlineRequests(requests)
          })
          .catch(response => {
            that.offlineFallback(r).then(f => {
              offline.deleteOfflineRequest(r.id)
            })
            return that.offlineRequests(requests)
          })
      })
    },
    // Extra operations (update local store/db etc)
    postProcessOfflineRequest(info) {
      const r = info.request
      const data = info.data
      const response = info.response
      console.log('----------------> POST PROCESS OFFLINE REQUEST')
      console.log(data, r, response)
      if (r.group === 'assignment' && r.method === 'POST') {
        const payload = {
          model_id: r.objectId,
          mediaId: data.id,
          data: response.data.data
        }
        switch (r.type) {
          case 'media_create':
            payload.collection_name = 'media'
            this.replaceMedia(payload)
            offline.updateAssignmentMedia(payload)
            break
          case 'scan_create':
            payload.collection_name = 'scans'
            this.replaceMedia(payload)
            offline.updateAssignmentMedia(payload)
            break
          default:
            break
        }
      }
    },

    setMeta(form) {
      let model_field =
        this.formData.schema.model_type.default == 'App\\Models\\CallAssignment'
          ? 'call_assignment_id'
          : 'call_id' //this will likely need extending
      this.formData.schema.model_id
        ? (this.formData.schema.model_id.default = this.activeCall[model_field])
        : null
      this.formData.schema.user_id
        ? (this.formData.schema.user_id.default = this.user.id)
        : null
      this.updateFormSchemas({
        form: form,
        value: this.formData
      })
    },

    fetchFormSchemas(form) {
      axios.get(this.endpoint.replace('{form}', form)).then(({ data }) => {
        this.formData = data.data
        if (this.getFormData[form]) {
          this.formData.data = this.getFormData[form]
        }
        this.setMeta(form)
      })
    }
  },

  watch: {
    isLogged: function() {
      if (this.isLogged === 1) {
        this.fetchUser()
        this.attachAuthHeader(this.$axios)
        this.readCalls()
      }
    },
    user: function() {
      const that = this
      if (!this.user) return
      Sentry.configureScope(function(scope) {
        scope.setUser({ email: that.user.email })
        scope.setExtra('engineer', that.user.full_name)
      })
      LogRocket.identify(that.user.id, {
        name: that.user.full_name,
        email: that.user.email
      })
    }
  },
  updated() {
    this.listenServiceWorker()
  }
}
</script>
